import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";

function ControlledCircularProgress({value, ...props}) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p className="text-[20px] font-medium">{value}%</p>
      </Box>
    </Box>
  );
}

export default ControlledCircularProgress;
